var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebinars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 45.75 40.75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#333530;stroke-miterlimit:10;stroke-width:1.75px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-1",
    points: "3.88 33.88 3.88 7.88 19.88 7.88"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-1",
    x1: 41.88,
    y1: 16.88,
    x2: 41.88,
    y2: 33.88
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M44.88,33.88h-17l-2,2h-5l-2-2H.88v3a3,3,0,0,0,3,3h38a3,3,0,0,0,3-3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M32.38.88c-6.91,0-12.5,4.25-12.5,9.49a8,8,0,0,0,2.36,5.55A19.52,19.52,0,0,1,21,20.8a.78.78,0,0,0,.92,1.05,18.92,18.92,0,0,0,6.2-2.56,16.11,16.11,0,0,0,4.29.58c6.9,0,12.5-4.25,12.5-9.5S39.28.88,32.38.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M19.88,31.88v-3c0-1.3-2.76-3-5-3s-5,1.7-5,3v3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M14.88,15.88a2.85,2.85,0,0,0-3,2.52v2a2.86,2.86,0,0,0,3,2.53,2.86,2.86,0,0,0,3-2.53v-2A2.86,2.86,0,0,0,14.88,15.88Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebinars);
export default __webpack_public_path__ + "static/media/Webinars.fb6c62f86abd980aefa8a3c5a7534c64.svg";
export { ForwardRef as ReactComponent };